module.exports = __webpack_public_path__ + "img/mainPicture.dc10dc50.jpg";